// Millimetres in one inch — the international-yard definition (1959),
// used as the pivot between metric print dimensions and pixel/inch
// (DPI) raster resolution.
const MM_PER_INCH = 25.4;

function convertFromLowDPIToHighDPI(unit: number = 1, lowDPI: number = 72, highDPI: number = 300): number {
    return (unit * highDPI) / lowDPI;
}

function convertMMToPixel(mm: number, dpi: number = 300): number {
    // Rounded to the nearest whole pixel: HTMLCanvasElement.width is
    // an unsigned integer, so a float would be silently floored by the
    // browser on export. Explicit Math.round makes the print-side pixel
    // dimension deterministic and centred on the true mm value.
    return Math.round((mm * dpi) / MM_PER_INCH);
}

export { convertFromLowDPIToHighDPI, convertMMToPixel };
